import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import svgData from "./svgData";
import { PathElement } from "../../../svgHelpers";
const PdfFile = (props) => (_jsxs(_Fragment, { children: [_jsx(PathElement, { ...props, path: svgData.path.d1, clipRule: "evenodd", fillRule: "evenodd" }), _jsx(PathElement, { ...props, path: svgData.path.d3 }), _jsx(PathElement, { ...props, path: svgData.path.d4 }), _jsx(PathElement, { ...props, path: svgData.path.d5 })] }));
export default PdfFile;
